<template>
  <div>
    <div class="row no-gutters">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Master Rentang Nilai Akademik'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')"
              style="z-index: 2;" />
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <ButtonComponent colors="#17A1FA" name="csv" @click.native="$func.exportCsv">
                </ButtonComponent>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="gradeLevels" :search="search" class="custom-header">
                <template v-slot:item.no="{ item,index }">
                  {{ item.no }}.
                </template>
                <template v-slot:item.rentang="{ item }">{{ item.min }} - {{ item.max }}</template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit', item)"
                    dataTitleTooltip="Edit" />
                  <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)"
                    dataTitleTooltip="Hapus" />
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>

        <b-modal @ok="onSubmit" size="lg" ok-title="Simpan" ok-variant="primary" cancel-title="Batal"
          cancel-variant="danger" id="modal" :title="`${statusModal} Rentang Nilai Akhir`">
          <b-form>
            <div class="row no-gutters">
              <div class="col-lg-6">
                <div class="row d-flex justify-content-between align-items-center">
                  <div class="col-lg-6">
                    <b-form-group label="Rentang Nilai Dari ">
                      <b-form-input type="number" required v-model="request.min"
                        placeholder="Masukkan Nilai Rentang Min"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-6">
                    <b-form-group label="Sampai">
                      <b-form-input type="number" required v-model="request.max"
                        placeholder="Masukkan Nilai Rentang Maks"></b-form-input>
                      <p class="text-danger" v-if="request.max > 100">*)Maksimal 100</p>
                    </b-form-group>
                  </div>
                </div>
                <div class="row d-flex justify-content-between align-items-center">
                  <div class="col-lg-12">
                    <b-form-group label="Nilai Mutu :">
                      <b-form-input type="text" required v-model="request.predicates"
                        placeholder="Masukkan Nilai Mutu"></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="row d-flex justify-content-between align-items-center">
                  <div class="col-lg-12">
                    <b-form-group label="Bobot :">
                      <b-form-input type="number" required v-model="request.weight"
                        placeholder="Masukkan Bobot"></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row d-flex justify-content-between align-items-center">
                  <div class="col-lg-12">
                    <b-form-group label="Predikat :">
                      <b-form-input type="text" required v-model="request.quality"
                        placeholder="Masukkan Predikat"></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </b-form>
          <template #modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="primary" @click="ok()"
              :disabled="(request.max === null || request.max > 100) ? true : false">
              Simpan
            </b-button>
            <b-button size="sm" variant="danger" @click="cancel()">
              Batal
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
import axios from "axios";

export default {
  data() {
    return {
      gradeLevels: [],
      search: "",
      headers: [
        { text: "No",value: "no" },
        { text: "Rentang Nilai", value: "rentang" },
        { text: "Bobot", value: "weight" },
        { text: "Nilai Mutu", value: "predicates" },
        { text: "Predikat", value: "quality" },
        { text: "Aksi", value: "action" }
      ],
      statusModal: '',
      maxWeights: '',
      request: {
        key: null,
        min: null,
        max: null,
        predicates: null,
        status: 't',
        weight: null,
        quality: null,
      }
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent,
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Rentang Nilai Akademik" }
    ]);

    await this.getData()

    // set csv export name and data
    this.$store.commit('updateCsvName', { name: 'Data Export Nilai', data: this.code4.desserts })
  },
  methods: {
    openModal(status, itemData = null) {
      this.statusModal = status

      // reset form
      this.request = {
        key: null,
        min: null,
        max: null,
        predicates: null,
        status: 't',
        weight: null,
        quality: null,
      }
      if (status == 'Edit') {
        this.request.key = itemData.key
        this.request.min = itemData.min,
          this.request.max = itemData.max,
          this.request.predicates = itemData.predicates,
          // this.request.status = itemData.status
          this.request.weight = itemData.weight,
          this.request.quality = itemData.quality

      }
    },

    async getData() {
      this.gradeLevels = []
      this.maxWeights = ''
      try {
        const result = await axios.get(`master/grade-levels`)

        // result.data.data.map((nilai, index) => {
        //   if (index+1 > 2 == 0) {
        //     const hasil = nilai[index-1]+nilai[index];
        //   }
        // });
        let sum = 0;
        result.data.data.forEach(function (item) {
          sum += (parseFloat(item.weight));
        });
        this.maxWeights = sum;
        result.data.data.map((grade, index) => {
          let obj = {
            key: grade.key,
            no: index+1,
            min: grade.min,
            max: grade.max,
            weight: grade.weight,
            predicates: grade.predicates,
            quality: grade.quality,
          };
          this.gradeLevels.push(obj);
        })
      } catch (err) {
          // this.$swal(`Failed`);
      }
    },

    async onSubmit() {
      const form = this.request

      if (form.key === null) {
        // store
        this.store(form)
      } else {
        // update
        this.update(form)
      }
    },

    async store(form) {
      try {
        let hasil = parseFloat(this.maxWeights) + parseFloat(form.weight);
        let formData = {
          min: form.min,
          max: form.max,
          predicates: form.predicates,
          status: 't',
          weight: form.weight,
          quality: form.quality,
        };

        if (hasil > 100.00) {
          this.$swal('Error', 'ini salah', 'OK');
        } else {
          if (form.quality.length > 2) {
            this.$swal('Error', 'Huruf mutu tidak boleh lebih dari 2 huruf', 'OK');
          } else {
            const result = await axios.post(`master/grade-level`, formData)

            this.refreshData(result, 'Store')
          }
        }

      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    async update(form) {
      try {
        let hasil = parseFloat(this.maxWeights) + parseFloat(form.weight);
        let formData = {
          min: form.min,
          max: form.max,
          predicates: form.predicates,
          status: 't',
          weight: form.weight,
          quality: form.quality,
        };

        if (hasil > 100.00) {
          this.$swal('Error', 'ini salah', 'OK');
        } else {
          // if (form.quality.length > 2) {
          //   this.$swal('Error', 'Nilai Mutu, Tidak boleh lebih dari 2 Huruf', 'OK');
          // } else {
            const result = await axios.put(`master/grade-level/${form.key}`, formData)
            this.refreshData(result, 'Update')
          // }
        }

      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    refreshData(result, alert) {
      if (result.data.meta.code == 200) {
        this.$swal(`Success ${alert} Data`);
        this.getData()
      } else {
          this.$swal(`Failed`);
      }
    },

    async deleteData(key) {
      try {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this item!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(async (result) => {
          if (result.value) {
            // User confirmed, so delete the item
            const result = await axios.delete(`master/grade-level/${key}`)
            this.refreshData(result, 'Delete')
          } else {
            // User canceled, so do nothing
          }
        })
      } catch (err) {
          this.$swal(`Failed`);
      }
    },
  }
}
</script>